<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="themeOptions.datalabels(datalabelsIndex).color">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-color-picker [itemColor]="color" [color]="themeOptions.datalabels(datalabelsIndex).color" (sendColor)="receiveValue($event)"></app-color-picker>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)" [information]="themeOptions.datalabels(datalabelsIndex, type).color">
    <div app-theme-option-content>
      <app-color-picker [itemColor]="color" [color]="themeOptions.datalabels(datalabelsIndex, type).color" (sendColor)="receiveValue($event, type)"></app-color-picker>
    </div>
  </app-theme-option>
</div>